import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ breakpoints, fontWeights, palette }: Theme) => ({
  root: {
    margin: 0,
    [breakpoints.up('md')]: {
      paddingTop: '4rem',
      paddingBottom: '4rem',
    },
  },
  title: {
    margin: '0 0 2rem',
    fontSize: '1.75rem',
    fontWeight: fontWeights.medium,
    lineHeight: 1.35,
  },
  subtitle: {
    margin: 0,
    color: palette.grey[700],
    fontSize: '0.75rem',
    fontWeight: fontWeights.medium,
    lineHeight: 1.3,
    textTransform: 'uppercase',
  },
  text: {
    display: 'flex',
    gap: '0.75rem',
    alignItems: 'center',
    padding: '0.75rem 1rem',
    border: `1px solid ${palette.grey[400]}`,
    borderRadius: '1rem',
    '&:last-of-type': {
      marginBottom: 0,
    },
  },
  list: {
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    margin: '0.75rem 0 0',
    padding: 0,
    '&:first-of-type': {
      marginBottom: '2rem',
      paddingBottom: '2rem',
      borderBottom: `1px solid ${palette.grey[400]}`,
    },
  },
  button: {
    marginTop: '2rem',
  },
  veevaNumber: {
    position: 'absolute',
    top: '0.25rem',
    left: '0.25rem',
    color: 'rgba(34, 34, 34, 0.1)',
    fontSize: '0.625rem',
    lineHeight: 1.1,
  },
}));
